import { createActionTypes, createNoLoadActionTypes } from './utils';

export const SET_QUOTES_DETAILS = createNoLoadActionTypes('SET_QUOTES_DETAILS');
export const GET_QUOTES_LIST = createActionTypes('GET_QUOTES_LIST');
export const GET_QUOTES_CONTACT_LIST = createNoLoadActionTypes('GET_QUOTES_CONTACT_LIST');
export const GET_QUOTES_STATUS = createNoLoadActionTypes('GET_QUOTES_STATUS');
export const QUOTE_SUMMARY_DELETE_QUOTE = createActionTypes('QUOTE_SUMMARY_DELETE_QUOTE');
export const SET_QUOTES_FILTERS = createNoLoadActionTypes('SET_QUOTES_FILTERS');
export const RESET_QUOTES = createNoLoadActionTypes('RESET_QUOTES');
